module.exports = __webpack_public_path__ + "static/cxl-7cb6cebb32d9558b260d1fb16dc4a887.png";